import { Injectable } from '@angular/core';
import { URLS } from '../constants/constants';
import { HeaderType } from '../enums/enums';
import { FilterModel } from '../interface/interface';
import { PasswordUpdatePayload, UserPayloadModel } from '../models/user.model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpService) {}

  createUser(payload: UserPayloadModel) {
    return this.http.post(URLS.users, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  deleteUser(id: string) {
    return this.http.delete(`${URLS.users}/${id}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  activateUser(id: string) {
    return this.http.put(
      `${URLS.users}/activate/${id}`,
      {},
      {
        params: { headerType: HeaderType.ACCESS },
      }
    );
  }

  fetchUserList(filter: FilterModel) {
    return this.http.get(URLS.users, {
      params: {
        headerType: HeaderType.ACCESS,
        search: filter.searchText,
        page: filter.pageNumber,
        limit: filter.limit,
      },
    });
  }

  updateUser(payload: UserPayloadModel) {
    return this.http.put(
      URLS.profile,
      { name: payload.name, phone: payload.phone },
      {
        params: {
          headerType: HeaderType.ACCESS,
        },
      }
    );
  }

  changePassword(payload: PasswordUpdatePayload) {
    return this.http.put(URLS.changePassword, payload, {
      params: {
        headerType: HeaderType.ACCESS,
      },
    });
  }
}
